// components/CookieBanner.jsx or CookieBanner.js
import React, { useEffect, useState } from "react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const getCookie = (name) => {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) return cookieValue;
      }
      return null;
    };

    if (!getCookie("cookiesAccepted")) {
      setIsVisible(true);
    }
  }, []);

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const handleAccept = () => {
    setCookie("cookiesAccepted", "true", 365);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      id="cookie-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 999,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
      }}
    >
      <div
        id="cookie-banner"
        style={{
          width: "100vw",
          backgroundColor: "#000",
          color: "#fff",
          padding: "15px",
          textAlign: "center",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div style={{ flex: 1, textAlign: "left" }}>
          <strong>Your choice regarding cookies on this site</strong>
          <p style={{ margin: "5px 0", fontSize: "14px" }}>
            We use cookies to optimise site functionality and give you the best
            possible experience.
          </p>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={{
              background: "none",
              border: "none",
              color: "#a3a3a3",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={() => alert("Settings coming soon...")}
          >
            Settings
          </button>
          <button
            style={{
              backgroundColor: "#ffa500",
              border: "none",
              color: "white",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={handleAccept}
          >
            I Accept Cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
